import React from 'react';
import { Descriptions } from 'antd';
import { Icon } from '@ant-design/compatible';
var article = ``
function RczpDetail(props) {
  var {title,list,content} = props
  const descriptionItem = ()=>{
    var arrayItem = []
    if (list&&list.length) {
      list.forEach(element => {
        arrayItem.push(
          <Descriptions.Item label={element.label}><div style={{minWidth: '420px'}}>{element.value}</div></Descriptions.Item>
        )
      });
    }
    return arrayItem
  }
  return (
    <div>
        <Descriptions bordered title={title} column={2}>
          {descriptionItem()}
        </Descriptions>
        <div style={{marginTop: '20px'}}>
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    </div>
  );
}

export default RczpDetail;
